import AvailabilityTable from './AvailabilityTable';

export default AvailabilityTable;
